export class EngubatorCommonSetting {
    key: string;
    description: string;
    value: string;
}